export default class DeliveryMethodManagementColumnModel {
	static DeliveryMethodManagementColumn = [
	  {
		  title: 'Required delivery',
		  align: 'left',
		  field: 'deliveryMethodName'
	  }
	]
}
